import { render } from "./UsersAutocomplete.vue?vue&type=template&id=2ae0e5b0&ts=true"
import script from "./UsersAutocomplete.vue?vue&type=script&lang=ts"
export * from "./UsersAutocomplete.vue?vue&type=script&lang=ts"

import "./UsersAutocomplete.vue?vue&type=style&index=0&id=2ae0e5b0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__